<mat-radio-group
  *ngIf="sortVal !== undefined"
  class="goal-radio-group"
  [(ngModel)]="sortVal"
  name="radio-group"
  (ngModelChange)="sortValChanged($event)"
>
  <mat-radio-button class="goal-radio-button" [value]="'ASC'" [id]="1">
    <span class="radio-text">
      Sort
      <ng-container *ngIf="column.id != -1">ASC</ng-container>
      <ng-container *ngIf="column.id == -1">
        <img
          [src]="'../../assets/images/status_sort_asc.svg'"
          class="status-sort-img"
          alt="Sort status ASC"
        />
      </ng-container>
    </span>
  </mat-radio-button>
  <mat-radio-button class="goal-radio-button" [value]="'DESC'" [id]="2">
    <span class="radio-text">
      Sort
      <ng-container *ngIf="column.id != -1">DESC</ng-container>
      <ng-container *ngIf="column.id == -1">
        <img
          [src]="'../../assets/images/status_sort_desc.svg'"
          class="status-sort-img"
          alt="Sort status DESC"
        />
      </ng-container>
    </span>
  </mat-radio-button>
  <mat-radio-button class="goal-radio-button" [value]="'CLEAR'" [id]="3">
    <span class="radio-text">No sort</span>
  </mat-radio-button>
</mat-radio-group>
